import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore } from "@obg/core.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable()
export class LgBannerConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCore>) {}

	getSlideWidth(): number {
		return this.configService.get((x) => x.coreUi.banner.slideWidth, 1190);
	}
}
